// src/pages/RestoreRequest.js  (ruta: /password/restore)
import React, { useRef, useState, useContext, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import SwaggerContext from "../../SwaggerContext";
import { createApiCallback } from "../../utils/error-handler";

/* Validaciones */
const atLeastOne = (_value, _props, components) => {
    const email = components.email?.[0]?.value?.trim() ?? "";
    const username = components.username?.[0]?.value?.trim() ?? "";
    if (!email && !username) {
        return (
            <div className="alert alert-danger" role="alert">
                Debes rellenar email o usuario.
            </div>
        );
    }
};

const validEmailOptional = (value) => {
    const v = value?.trim();
    if (v && !isEmail(v)) {
        return <div className="alert alert-danger" role="alert">Email no válido</div>;
    }
};

const SendRestore = () => {
    const form = useRef();
    const checkBtn = useRef();

    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const navigate = useNavigate();
    const { userApi } = useContext(SwaggerContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSuccessMsg("");
        setErrorMsg("");

        form.current.validateAll();
        if (checkBtn.current.context._errors.length > 0) return;

        const payload = { email: email.trim() || undefined, username: username.trim() || undefined };

        // Ajusta a tu backend: p.ej., userApi.requestPasswordRestore(payload, cb)
        userApi.sendRestore(payload, createApiCallback(
            () => {
                setSuccessMsg("Si los datos existen, recibirás un correo con instrucciones.");
            },
            (errorMessage, errorInfo) => {
                if (errorInfo.statusCode === 404) {
                    setErrorMsg("Usuario no encontrado.");
                } else {
                    setErrorMsg(`No se ha podido iniciar la restauración: ${errorMessage}`);
                }
            }
        ));
    };

    return (
        <div className="col-md-12">
            <div className="card card-container">
                <img
                    src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                    alt="profile-img"
                    className="profile-img-card"
                />

                <h4 className="text-center mt-3 mb-4">
                    Solicitud de restablecimiento de contraseña
                </h4>
                <p className="text-muted text-center px-3">
                    Introduce tu <strong>email</strong> o <strong>usuario</strong>.
                    Si existen en el sistema, recibirás un correo con un enlace para restablecer tu contraseña.
                </p>

                <Form onSubmit={handleSubmit} ref={form}>
                    <Fragment>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <Input
                                type="text"
                                className="form-control"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                validations={[atLeastOne, validEmailOptional]}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="username">Usuario</label>
                            <Input
                                type="text"
                                className="form-control"
                                name="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                validations={[atLeastOne]}
                            />
                        </div>

                        <div className="form-group d-flex justify-content-center pt-4">
                            <button className="btn btn-primary">Enviar enlace de restablecimiento</button>
                        </div>
                    </Fragment>

                    {successMsg && (
                        <div className="form-group mt-3">
                            <div className="alert alert-success" role="alert">
                                {successMsg}
                            </div>
                        </div>
                    )}

                    {errorMsg && (
                        <div className="form-group mt-3">
                            <div className="alert alert-danger" role="alert">
                                {errorMsg}
                            </div>
                        </div>
                    )}

                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>

                <div className="text-center mt-3">
                    <button
                        type="button"
                        className="btn btn-link"
                        onClick={() => navigate("/login")}
                    >
                        Iniciar sesión
                    </button>
                </div>
            </div>
        </div>
    );

};

export default SendRestore;
